import React, { Component } from "react";
import Box from "@material-ui/core/Box";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AttachFile from "@material-ui/icons/AttachFile";
import { DropzoneArea } from "material-ui-dropzone";
import AdmissionContext from "../AdmissionContext";
import { ShowRequiredField, kPButton } from "../global";

import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";


class AttachmentView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);

    this.state = {
      dzKey: 0,
      croppedImageUrl: '',
      croppedBase64: '',
      cropImage: false,
      src: null,
      crop: {
        unit: "px",
        width: 300,
        height: 300,
      },
    };
  }

  checkRequireFields = (index) => {
    const { attachment } = this.context; 
    if (attachment.required) {
      return ShowRequiredField("Attach Documents");
    }
    return null;
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { attachment } = this.context;
    if (attachment.imgPicture.length <= 0) {
      attachment.required = true;
      this.context.SetAttachment(attachment);
    } else {
      this.context.btnNextClicked();
    }
  };

  acceptCropButtonClicked = () => {
    const { attachment } = this.context;    
    if(this.state.croppedBase64 !== ''){
      attachment.required = false;
      attachment.imgPicture[0] = this.state.croppedBase64;
      this.context.SetAttachment(attachment);
      var tmpkey = this.state.dzKey + 1;
      this.setState({cropImage : false, dzKey: tmpkey});
    }
  };

  cancelCropButtonClicked = () => {
    var tmpkey = this.state.dzKey + 1;
    this.setState({cropImage : false, dzKey: tmpkey});
  };

  handleGoodMoral(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgGoodMoral = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgGoodMoral.push(reader.result);
      };
    });

    this.context.SetAttachment(attachment);
  }

  deleteGoodMoral() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgGoodMoral = [];
    this.context.SetAttachment(attachment);
  }


  handleBirthCertificate(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgBirthCertificate = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgBirthCertificate.push(reader.result);
      };
    });

    this.context.SetAttachment(attachment);
  }

  deleteBirthCertificate() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgBirthCertificate = [];
    this.context.SetAttachment(attachment);
  }

  handleReportCard(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgReportCard = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgReportCard.push(reader.result);
      };
    });

    this.context.SetAttachment(attachment);
  }

  deleteReportCard() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgReportCard = [];
    this.context.SetAttachment(attachment);
  }

  // handlePicture(files) {
  //   const { attachment } = this.context;

  //   files.forEach((element) => {
  //     let reader = new FileReader();
  //     reader.readAsDataURL(element);
  //     reader.onloadend = () => {
  //       if(attachment.imgPicture.length > 0){
  //         if(attachment.imgPicture[0] !== reader.result){
  //           this.setState({ src: reader.result, cropImage: true });  
  //         }
  //       } else {
  //         this.setState({ src: reader.result, cropImage: true });
  //       }        
  //     };
  //   });
  // }

  handlePicture(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgPicture = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgPicture.push(reader.result);          
      };
    });

    this.context.SetAttachment(attachment);
  }

  deletePicture() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgPicture = [];
    this.context.SetAttachment(attachment);    
  }

  handleCopyofTOR(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgCopyofTOR = "";

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgCopyofTOR = reader.result;
      };
    });

    this.context.SetAttachment(attachment);
  }

  handleClearance(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgClearance = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgClearance.push(reader.result);          
      };
    });

    this.context.SetAttachment(attachment);
  }

  deleteClearance() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgClearance = [];
    this.context.SetAttachment(attachment);    
  }

  handleEvaluation(files) {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgEvaluation = [];

    files.forEach((element) => {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        attachment.imgEvaluation.push(reader.result);          
      };
    });

    this.context.SetAttachment(attachment);
  }

  deleteEvaluation() {
    const { attachment } = this.context;
    attachment.required = false;
    attachment.imgEvaluation = [];
    this.context.SetAttachment(attachment);    
  }



  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);

        //create base64
        let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.setState({ croppedBase64:  reader.result});
        };

        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  render() {


    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Attach Documents
                  </Box>
                </Typography>

                {this.showUnderGraduateRequirements()}
                {this.showGraduateRequirements()}
                {this.showCropImage()}
                {this.checkRequireFields(0)}

                {/* BUTTON         */}
                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }

  showUnderGraduateRequirements = () => {
    const { studentType, attachment } = this.context;
    if (studentType.academic.description.toLowerCase() === "undergraduate") {
      return (
        <Box>
          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Good Moral
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgGoodMoral}
              onChange={this.handleGoodMoral.bind(this)}
              onDelete={this.deleteGoodMoral.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Birth Certificate (PSA)
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgBirthCertificate}
              onChange={this.handleBirthCertificate.bind(this)}
              onDelete={this.deleteBirthCertificate.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Form 138/Report Card
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgReportCard}
              onChange={this.handleReportCard.bind(this)}
              onDelete={this.deleteReportCard.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              1x1 Picture
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea key={this.state.dzKey}
              Icon={AttachFile}
              initialFiles={attachment.imgPicture}
              onChange={this.handlePicture.bind(this)}
              onDelete={this.deletePicture.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>  

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Clearance Form (for returning students)
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea key={this.state.dzKey}
              Icon={AttachFile}
              initialFiles={attachment.imgClearance}
              onChange={this.handleClearance.bind(this)}
              onDelete={this.deleteClearance.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>  

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
            Evaluation Form (Transferee)
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea key={this.state.dzKey}
              Icon={AttachFile}
              initialFiles={attachment.imgEvaluation}
              onChange={this.handleEvaluation.bind(this)}
              onDelete={this.deleteEvaluation.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>  

          


        </Box>
      );
    }
  };

  showGraduateRequirements = () => {
    const { studentType, attachment } = this.context;

    if (studentType.academic.description.toLowerCase() === "graduate") {
      return (
        <Box>
          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Original copy of TOR
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgCopyofTOR}
              onChange={this.handleCopyofTOR.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Birth Certificate (PSA)
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgBirthCertificate}
              onChange={this.handleBirthCertificate.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>

          <Typography component="div">
            <Box fontSize={14} color="#808080" display="flex" pt={2} ml={2}>
              Passport Size Picture
            </Box>
          </Typography>

          <Box pt={2} width="100" height="50">
            <DropzoneArea
              Icon={AttachFile}
              initialFiles={attachment.imgPicture}
              onChange={this.handlePicture.bind(this)}
              maxFileSize={5000000}
              dropzoneText={"Drag and drop an image here or click"}
              acceptedFiles={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/bmp",
              ]}
              showAlerts={false}
              showPreviews={false}
              filesLimit={1}
            />
          </Box>
        </Box>
      );
    }
  };

  showCropImage = () => {
    const { crop, croppedImageUrl, src } = this.state;

    return (
      <Dialog fullScreen={true} open={this.state.cropImage}>
        <Box justifyContent="center" display="flex" pt={3}>
          {src && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          )}
        </Box>

        <Box justifyContent="center" display="flex" pt={3}>
          {croppedImageUrl && (
            <Box>
              <Typography component="div">
                <Box
                  fontWeight={500}
                  fontSize={22}
                  color="#388e3c"
                  display="flex"
                  justifyContent="flex-start"
                >
                  Result
                </Box>
              </Typography>

              <img
                alt="Crop"
                style={{ maxWidth: "100%" }}
                src={croppedImageUrl}
              />
            </Box>
          )}
        </Box>

        <Box justifyContent="center" display="flex" pt={3} fontSize={14}>
          <Box width={200} justifyContent="flex-start">
            <Button
              fullWidth={true}
              style={kPButton}
              variant="contained"
              onClick={() => {
                this.cancelCropButtonClicked();
              }}
            >
              Cancel
            </Button>
          </Box>

          <Box width={200} minHeight={100} pl={2}>
            <Button
              fullWidth={true}
              style={kPButton}
              variant="contained"
              onClick={() => {
                this.acceptCropButtonClicked();
              }}
            >
              Accept
            </Button>
          </Box>
        </Box>

        <Box pt={3}></Box>
      </Dialog>
    );
  };
}

export default AttachmentView;
